import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { VarHealthcareDocument, VarHealthcareDocumentSearch } from '@entity/var-healthcare';

@Injectable({
  providedIn: 'root',
})
export class VarHealthcareService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = 'api/1.0/varhealthcare';

  search(query: string): Observable<VarHealthcareDocumentSearch> {
    return this.httpClient.get<VarHealthcareDocumentSearch>(`${this.baseUrl}/search?query=${query}`);
  }

  getDocument(id: number): Observable<VarHealthcareDocument | null> {
    return this.httpClient.get<VarHealthcareDocument>(`${this.baseUrl}/documents/${id}`).pipe(
      // An unknown VAR code returns 404; treat it as "no document" instead of letting the
      // error bubble up to Angular's global ErrorHandler (see Sentry TACS2-2019-DASHBOARD-24).
      catchError((error: HttpErrorResponse) => (error.status === 404 ? of(null) : throwError(() => error)))
    );
  }
}
